<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="currencyRates"
              :items-per-page="50"
              item-key="id"
              sort-by="exchangeDate"
              :sort-desc=true
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Currency Rates</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Currency Rate</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select From Currency"
                                v-model="editedItem.fromCurrency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md6>
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select To Currency"
                                v-model="editedItem.toCurrency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md6>                              
                              <DatePicker picker-label="Exchange Date" :date-value="editedItem.exchangeDate" @dateSelected="editedItem.exchangeDate=$event" /> 
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.rate" label="Rate"></v-text-field>
                            </v-flex>                                                                                                                                                                                                    
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
const CURRENCIES_API_URL = 'definitions/currencies';
const API_URL = 'definitions/currencyRates';
export default {
    components:{
      LeftMenu,
      DatePicker
    },
    data () {
    return {
      dialog: false,
      search: '',
      currencyList: [],
      currencyRates: [
        {     
          model: '',
          category: '',
          explanation: '',           
        },               
      ],
      editedIndex: -1,
      editedItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Exchange Date', align: 'left', sortable: true, value: 'exchangeDate'},
        { text: 'From Currency',  value: 'fromCurrency.text'  },
        { text: 'To Currency',  value: 'toCurrency.text'  },       
        { text: 'Rate',  value: 'rate'  },  
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Currency Rate' : 'Edit Currency Rate'
    },
  },
  created() {    
    this.getCurrencies();
    this.getCurrencyRates();    
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.currencyRates.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.currencyRates.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.currencyRates.splice(index, 1);
        this.deleteCurrencyRate(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateCurrencyRate(this.editedItem);
      } else {
        this.addCurrencyRate(this.editedItem);         
      }      
    },
    addCurrencyRate(item){
      this.$axios.post(this.$apiurl + API_URL, {
        exchangeDate: item.exchangeDate,
        fromCurrency: item.fromCurrency,
        toCurrency: item.toCurrency,
        rate: item.rate,
      })
      .then(response => {        
        if (response.status === 201) {
          this.currencyRates.push(this.editedItem);
          this.close();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateCurrencyRate(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        exchangeDate: item.exchangeDate,
        fromCurrency: item.fromCurrency,
        toCurrency: item.toCurrency,
        rate: item.rate,
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.currencyRates[this.editedIndex], this.editedItem);
          this.close();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteCurrencyRate(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getCurrencyRates(){     
      this.$axios.get(this.$apiurl + API_URL)
        .then(response => {
            this.currencyRates = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
